// @flow

import React, { type Element, useState } from 'react'
import { Container } from '@material-ui/core'
import BCPEnrollmentCheckbox from '../BCPEnrollmentCheckbox'
import PrivateFacility from '../PrivateFacility'
import type { PrivateFacility as Facility } from '../types'

type Props = {|
  isBcpEnrolled: boolean,
  createdFacilities: Array<Facility>,
  handleServerErrors: ({ [string]: Array<string> }) => void,
  setFacilityToAdd?: (any) => void,
  setFacilityToDelete?: (string) => void,
|}

function BcpContainer({
  isBcpEnrolled,
  createdFacilities,
  setFacilityToAdd,
  setFacilityToDelete,
  handleServerErrors,
}: Props): Element<typeof React.Fragment> {
  const [bcpEnrolled, setBcpEnrolled] = useState(isBcpEnrolled)

  return (
    <Container maxWidth="md" disableGutters>
      <BCPEnrollmentCheckbox
        checked={bcpEnrolled}
        setChecked={setBcpEnrolled}
        handleServerErrors={handleServerErrors}
      />
      {bcpEnrolled && (
        <PrivateFacility
          handleServerErrors={handleServerErrors}
          createdFacilities={createdFacilities}
          setFacilityToAdd={setFacilityToAdd}
          setFacilityToDelete={setFacilityToDelete}
        />
      )}
    </Container>
  )
}

export default BcpContainer
